import { jsx as _jsx } from "react/jsx-runtime";
import { UserProfile } from 'components/userProfile/userProfile';
import { useConversationRow } from '../../../utils/useConversationRow';
import styles from './conversationsTableCustomer.module.scss';
/** Represents the content of the customer cell in the conversations table. */
export const ConversationsTableCustomer = () => {
    const { conversationAndRequester: { conversation, requester }, } = useConversationRow();
    const subject = conversation.initial_channel === 'email' ||
        conversation.initial_channel === 'contact_form'
        ? conversation.attributes.subject
        : undefined;
    const description = conversation.is_abandoned ? 'Abandoned' : subject;
    return (_jsx(UserProfile, { user: requester, truncateName: true, description: description, descriptionClassName: styles.description }));
};
